
import React from 'react';
import Carousel from '../components/Carousel';
import ServicesGrid from '../components/ServicesGrid';
import HowItWorks from '../components/HowItWorks';

function Home() {
  return (
    <>
      <Carousel />
      <div className="container">
        <ServicesGrid />
        <HowItWorks />
      </div>
    </>
  );
}

export default Home;
